import * as React from 'react';
import { useSelector } from 'react-redux';
import { ModalWindow } from '@cian/ui-kit';

import { OnboardingContainer } from '../../parts';

import { useAppDispatch } from '../../../../hooks';
import {
  trackCloseOnboardingModal,
  trackShowOnboardingModal,
  trackClickOnboardingBackButton,
  trackClickOnboardingButton,
} from './tracking';

import { selectIsNewDreamOnboardingOpen } from '../../../../selectors/page';
import { openNewDreamOnboardingModal } from '../../../../slices';
import { ONBOARDING_SLIDES } from './content';
import { IOnboardingProps } from '../../types';

export const NewDreamOnboardingContainer: React.FC<Pick<IOnboardingProps, 'onFinishClick'>> = ({ onFinishClick }) => {
  const dispatch = useAppDispatch();

  const isOnboardingModalOpen = useSelector(selectIsNewDreamOnboardingOpen);

  const handleCloseModal = React.useCallback(() => {
    dispatch(openNewDreamOnboardingModal(false));
    trackCloseOnboardingModal();
  }, [dispatch]);

  return (
    <ModalWindow open={isOnboardingModalOpen} onClose={handleCloseModal}>
      <OnboardingContainer
        slides={ONBOARDING_SLIDES}
        trackShowOnboardingModal={trackShowOnboardingModal}
        trackClickOnboardingButton={trackClickOnboardingButton}
        trackClickOnboardingBackButton={trackClickOnboardingBackButton}
        closeOnboardingModal={handleCloseModal}
        onFinishClick={onFinishClick}
      />
    </ModalWindow>
  );
};
